import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "linear",
  "name": "Linear",
  "category": "integrations",
  "description": "Create and manage issues in Linear",
  "icon": "siLinear",
  "iconType": "simple-icon",
  "color": "purple",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Linear",
    "color": "#5e6ad2"
  },
  "credentials": [
    {
      "name": "linearApi",
      "required": true,
      "displayName": "Linear API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "linear",
    "issues",
    "project-management",
    "tasks",
    "tickets"
  ],
  "comingSoon": true
};

export default definition;
